import { Box, Tooltip } from "@mantine/core"
import { UseFormReturnType } from "@mantine/form"
import { Button, EqualWidthGrid } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import { CertificateUpdateDto } from "@tfg/types/schemas/modules/traceability/commands/update-certificate/update-certificate.request.dto"

import classes from "~/assets/css/Certificates.module.css"

type Handler = {
  open: () => void
  close: () => void
  toggle: () => void
}
type Props = {
  form: UseFormReturnType<CertificateUpdateDto>
  rejectHandler: Handler
  successModalHandler: Handler
}

export function CertificateFormSubmitButton({
  form,
  rejectHandler,
  successModalHandler,
}: Props) {
  const { t } = useTranslation("certificates")
  return (
    <EqualWidthGrid>
      <Box style={{ flex: 0.3 }}>
        <Tooltip
          label={t("modal.rejectToolTips")}
          fz="xs"
          maw={250}
          multiline={true}
        >
          <Button
            mt="sm"
            fullWidth={true}
            onClick={rejectHandler.open}
            variant="tertiary-critical"
            className={classes.certificateButton}
          >
            {t("modal.reject")}
          </Button>
        </Tooltip>
      </Box>

      <Box style={{ flex: 0.7 }}>
        <Button
          fullWidth={true}
          disabled={!form.isValid()}
          onClick={successModalHandler.open}
          mt="sm"
        >
          {t("modal.submit")}
        </Button>
      </Box>
    </EqualWidthGrid>
  )
}
